import { useState, useEffect } from 'react';
import { ComponentsOverview } from '../ComponentsOverview';
import { PointsOfInterest } from '../PointsOfInterest';
import { BasicTabs } from '@/components/shared/BasicTabs';
import { FloatingLine, tabStyles } from './styles';
import { useRouter, useInsightsPageParams } from '@/hooks';

const tabs = [
  { label: 'Component overview', component: <ComponentsOverview />, id: 'component-overview' },
  { label: 'Points of Interest', component: <PointsOfInterest />, id: 'points-of-interest' },
].map((tab, index) => ({
  ...tab,
  index,
}));

const getValidTabIndex = (tabIndex: number) => {
  return tabIndex >= 0 && tabIndex < tabs.length ? tabIndex : 0;
};

export const TabNavigation = () => {
  const router = useRouter();
  const { getCurrentParams, setOverviewTab } = useInsightsPageParams();

  const [selectedTab, setSelectedTab] = useState(() => {
    const urlParams = getCurrentParams();
    const urlTab = urlParams.overviewTab ? parseInt(urlParams.overviewTab as string, 10) : 0;
    return getValidTabIndex(urlTab);
  });

  const handleTabChange = (tabIndex: number) => {
    setSelectedTab(tabIndex);
    setOverviewTab(tabIndex.toString());
  };

  useEffect(() => {
    const urlParams = getCurrentParams();
    const urlTab = urlParams.overviewTab ? parseInt(urlParams.overviewTab as string, 10) : 0;
    const validTab = getValidTabIndex(urlTab);

    if (validTab !== selectedTab) {
      setSelectedTab(validTab);
    }
  }, [router.pathname, selectedTab, getCurrentParams]);

  return (
    <BasicTabs
      tabs={tabs}
      selectedTab={selectedTab}
      changeTab={handleTabChange}
      tabsStyles={tabStyles}
      customSeperator={<FloatingLine />}
      tabIdPrefix="review-panel-tab"
    />
  );
};
